import { render, staticRenderFns } from "./BrandEdit.vue?vue&type=template&id=04ec34e8&"
import script from "./BrandEdit.vue?vue&type=script&lang=js&"
export * from "./BrandEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BrandEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports